import * as React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Stars = styled.div<{ fontSize?: number }>`
    color: #757575;
    display: inline-block;
    font-size: ${props => (props.fontSize ? `${props.fontSize}px` : 'inherit')};
`;

const HalfStarContainer = styled.div`
    display: inline-block;
    position: relative;
    vertical-align: top;
    width: 2.25em;

    svg {
        position: absolute;
        left: 0;
        top: 0;
    }
`;

interface Props {
    performerRankingPoints: number;
    fontSize?: number;
}

export default function PerformerStars({
    performerRankingPoints,
    fontSize
}: Props) {
    let fullStars = Math.floor(performerRankingPoints / 20);
    const overflow = performerRankingPoints % 20;
    if (overflow >= 15) {
        fullStars++;
    }
    const hasHalfStar = 5 < overflow && overflow < 15;
    return (
        <Stars fontSize={fontSize} title={`${performerRankingPoints}`}>
            {[1, 2, 3, 4, 5].map(val => {
                if (val <= fullStars) {
                    return (
                        <FontAwesomeIcon
                            key={`star_${val}`}
                            icon={['fas', 'star']}
                            size="2x"
                        />
                    );
                } else if (val === fullStars + 1 && hasHalfStar) {
                    return (
                        <HalfStarContainer key={`star_${val}`}>
                            <FontAwesomeIcon icon={['far', 'star']} size="2x" />
                            <FontAwesomeIcon
                                icon={['fas', 'star-half']}
                                size="2x"
                            />
                        </HalfStarContainer>
                    );
                } else {
                    return (
                        <FontAwesomeIcon
                            key={`star_${val}`}
                            icon={['far', 'star']}
                            size="2x"
                        />
                    );
                }
            })}
        </Stars>
    );
}
